import React, { useState } from 'react';
import EquipmentDetail from '../../components/EquipmentDetail/EquipmentDetail';
import { Box, InputAdornment, IconButton, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const Equipment = () => {
  const [serialNumber, setSerialNumber] = useState('');
  const [equipmentSerialNumber, setEquipmentSerialNumber] = useState('');

  const onEquipmentSerialNumberChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setEquipmentSerialNumber(event.target.value.toUpperCase());
  }

  const onEquipmentSerialNumberKeyPress = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (['Enter', 'NumpadEnter'].includes(event.key)) {
      setSerialNumber(equipmentSerialNumber);
    }
  }

  return (
    <Box sx={{ mt: 4, mx: 3 }}>
      <TextField
        id="outlined-basic"
        label="Equipment Serial Number"
        variant="outlined"
        value={equipmentSerialNumber}
        onChange={onEquipmentSerialNumberChange}
        onKeyDown={onEquipmentSerialNumberKeyPress}
        fullWidth
        sx={{ maxWidth: 300 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                color="primary"
                onClick={() => setSerialNumber(equipmentSerialNumber)}
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <Box sx={{ mt: 2, mb: 4 }}>
        <EquipmentDetail equipmentSerialNumber={serialNumber} />
      </Box>
    </Box>
  );
}

export default Equipment;
